import React from 'react'

interface Props {
    tag: string
    className?: string
}

const DiscountTag = ({ tag, className = '' }: Props) => {
    return (
        <span
            className={`discount-minimal-tag absolute top-2.5 right-2.5 z-20 h-5 px-2.5 inline-flex items-center justify-center text-[9px] font-bold text-white bg-gradient-to-r from-[#ff7a29] to-[#ff5a00] rounded-full uppercase tracking-wider select-none pointer-events-none ${className}`}
        >
            <span className="leading-none flex items-center justify-center">{tag}</span>

            <style dangerouslySetInnerHTML={{ __html: `
                @keyframes minimalPulse {
                    0%, 100% {
                        box-shadow: 0 1px 3px rgba(255, 90, 0, 0.25);
                    }
                    50% {
                        box-shadow: 0 0 8px 1px rgba(255, 106, 0, 0.55);
                    }
                }
                .discount-minimal-tag {
                    animation: minimalPulse 2.4s ease-in-out infinite;
                }
            ` }} />
        </span>
    )
}

export default DiscountTag
